import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import FixedBody from '../../ui/Common/FixedBody';

class CianUnionModal extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      timer: props.timer
    };

    this.handleClickOpenLink = this.handleClickOpenLink.bind(this);
    this.handleClickCancel = this.handleClickCancel.bind(this);
  }

  componentDidMount () {
    const { timer, visible, cianModalContext } = this.props;
    if (visible === true && timer !== null) {
      this.timer = setInterval(() => {
        this.setState((prevState) => ({ timer: prevState.timer - 1 }));
        if (this.state.timer === 0) {
          clearInterval(this.timer);
          window.location.href = `${cianModalContext.link}` || window.location.replace(`${cianModalContext.link}`);
        }
      }, 1e3);
    }
  }

  componentWillUnmount () {
    clearInterval(this.timer);
  }

  handleClickOpenLink () {
    const { onClose, cianModalContext } = this.props;
    window.location.href = `${cianModalContext.link}`;
    onClose();
  };

  handleClickCancel () {
    const { onClose } = this.props;
    clearInterval(this.timer);
    onClose();
  };

  render () {
    const { visible, cianModalContext } = this.props;
    const { timer } = this.state;
    return (
      <div className='modal-map'>
        <Modal
          isOpen={visible}
          onRequestClose={() => this.handleClickCancel()}
          portalClassName='cian-union-modal'
          className='cian-union-modal__content'
          overlayClassName='cian-union-modal__overlay'
        >
          <FixedBody />
          <div className='cian-union-modal-container'>
            <div className='banner-cian-union'>&nbsp;</div>
            <div className='cian-union-text-container'>
              <button type='button' className='close' onClick={() => this.handleClickCancel()}>×</button>
              <div className='cian-union-text-header'>
                {cianModalContext.title}
              </div>
              <div className='cian-union-text-description'>
                {cianModalContext.description}
              </div>
              <div className='cian-union-controls'>
                <div className='cian-union-buttons'>
                  <button
                    type='button'
                    className='btn btn-primary'
                    onClick={() => this.handleClickOpenLink()}
                  >
                    Перейти на Циан
                  </button>
                  <button
                    type='button'
                    className='btn-base btn-primary btn-empty-orange'
                    onClick={() => this.handleClickCancel()}
                  >
                    Остаться на МЛСН
                  </button>
                </div>
                {this.props.timer &&
                  <div className='cian-union-timer'>
                    Автопереход через {timer} сек
                  </div>
                }
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

CianUnionModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  timer: PropTypes.number,
  cianModalContext: PropTypes.any.isRequired
};

CianUnionModal.defaultProps = {
  timer: null
};

export default CianUnionModal;



// WEBPACK FOOTER //
// ./src/ui/CianUnion/CianUnionModal.jsx